<template>

  <div class="padded">
    <h2><i class="fa fa-share-alt" />&nbsp;Requests Report</h2>

    <requests-chart :stats="rtxStats" />

    <center><check-box v-model="sry" no-form>View Summary</check-box></center>

    <data-table

       v-if="!sry"

       ref="rtxtable"
       table-ref="rtxtable"
       title="Requests Report"

       :url="'/report/requests/summary' + (isTelco() ? '/' + this.org().id : (sharer ? '/' + sharer : ''))"

       :fields="fields"

       sort-field="targetDate|desc,priority|asc"
       detail-component="request-report-detail-row">

    <template #rtxDetails="props">

      <el-row>
        <el-col v-if="props.rowData.partyNo === 1" :span="16">

          <span :is="heading" :class="formatRequest(props.rowData.actionType)">
            <b>{{props.rowData.actionType}}</b> {{props.rowData.status}} ({{props.rowData.stepNo}}):
          </span>
          <span :is="heading">&nbsp;
            <b>[<span class="text-warning">{{props.rowData.shortRequestor}}<span v-if="props.rowData.telcoSiteId">&nbsp;{{props.rowData.telcoSiteId}}</span></span>]
              &nbsp;{{props.rowData.siteName}}
            </b>
            &nbsp;<small>Step {{props.rowData.currentStep}} / {{formatInteger(props.rowData.totalSteps)}}</small>
          </span>

          <p>
            Total Files: <b>{{formatInteger(props.rowData.totalFiles)}}</b>
            <span class="text-primary" v-if="props.rowData.uploadedFiles > 0">&nbsp;|&nbsp;Uploaded Files: <b>{{formatInteger(props.rowData.uploadedFiles)}}</b></span>
            <span class="text-info" v-if="props.rowData.approved > 0">&nbsp;|&nbsp;Approved Steps: <b>{{formatInteger(props.rowData.approved)}}</b></span>
            <span class="text-primary" v-if="props.rowData.approved > 0">&nbsp;|&nbsp;Completed Steps: <b>{{formatInteger(props.rowData.completed)}}</b></span>
          </p>

        </el-col>

        <el-col v-if="props.rowData.partyNo === 1 && isActive(props.rowData)" :span="8" align="right">
          <!-- eslint-disable-next-line vue/no-v-html -- formatter output, enum → icon markup -->
          <span v-if="props.rowData.priority"><span v-html="formatPriority(props.rowData.priority)" />&nbsp;|&nbsp;</span>
          <el-tooltip :content="formatFriendlyDate(props.rowData.targetDate)" placement="top">
            <!-- eslint-disable-next-line vue/no-v-html -- formatter output, enum → icon markup -->
            <span v-html="formatStatus(props.rowData.timeline)" />
          </el-tooltip>
        </el-col>
      </el-row>

      <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" align="left">
            <b>{{props.rowData.partyName}}</b>&nbsp;<span class="text-info">(Files <b>{{props.rowData.partyFiles}}/{{props.rowData.totalPartyFiles}}</b>)</span>
          </el-col>

          <el-col :xs="24" :sm="24" :md="12" :lg="14" align="center">
            <el-progress  :stroke-width="10" :percentage="Number(props.rowData.percent)" :color="customColors"></el-progress>
          </el-col>
        </el-row>

    </template>

  </data-table>


  </div>

</template>

<script>

import Vue from 'vue'

import RequestMixins from '@/mixins/RequestMixins'

import RequestsChart from '@/components/dashboard/charts/RequestsChart'
import RequestReportDetails from '@/components/dashboard/requests/RequestReportDetails'

Vue.component('request-report-detail-row', RequestReportDetails)


export default {
  mixins: [RequestMixins],

  components: {
    RequestsChart
  },

  props: {
    sharer: {
      type: Number,
      default: null
    },

    summary: {
      type: Boolean,
      default: false
    }

  },

  methods: {

    initChart () {
      this.chart = [
        [['Rejected ' + this.formatInteger(this.rtxStats.rtsRejected), this.rtxStats.rtsRejected], ['Active ' + this.formatInteger(this.rtxStats.rts), this.rtxStats.rts], ['Closed ' + this.formatInteger(this.rtxStats.rtsClosed), this.rtxStats.rtsClosed]],
        [['Rejected ' + this.formatInteger(this.rtxStats.rtuRejected), this.rtxStats.rtuRejected], ['Active ' + this.formatInteger(this.rtxStats.rtu), this.rtxStats.rtu], ['Closed ' + this.formatInteger(this.rtxStats.rtuClosed), this.rtxStats.rtuClosed]],
        [['Rejected ' + this.formatInteger(this.rtxStats.rtbRejected), this.rtxStats.rtbRejected], ['Active ' + this.formatInteger(this.rtxStats.rtb), this.rtxStats.rtb], ['Closed ' + this.formatInteger(this.rtxStats.rtbClosed), this.rtxStats.rtbClosed]],
        [['Rejected ' + this.formatInteger(this.rtxStats.rtdRejected), this.rtxStats.rtdRejected], ['Active ' + this.formatInteger(this.rtxStats.rtd), this.rtxStats.rtd], ['Closed ' + this.formatInteger(this.rtxStats.rtdClosed), this.rtxStats.rtdClosed]],
      ]

    },

    formatRequest (requestType) {

      if (!requestType) {
        return 'text-muted'
      }

      switch (requestType.toLowerCase()) {
        case 'rts': return 'text-success'
        case 'rtu': return 'text-primary'
        case 'rtb': return 'text-info'
        case 'rtd': return 'text-danger'
        default: return 'text-info'
      }
    }

  },



  watch: {

    stats: function(stats) {

      if (stats) {

        this.rtxStats = stats

      } else {

        this.rtxStats = this.getStats()

      }

      this.initChart ()

    }

  },



  data () {
    return {
      heading: 'h5',
      sry: this.summary,
      rtxStats: this.getStats(),
      customColors: [
        {color: '#E9E9EB', percentage: 0},
        {color: '#F56C6C', percentage: 10},
        {color: '#E6A23C', percentage: 30},
        {color: '#C6E2FF', percentage: 60},
        {color: '#409EFF', percentage: 90},
        {color: '#67C23A', percentage: 100}
      ],
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: '__slot:rtxDetails',
          title: 'Progress'
        }
      ]
    }
  },

  created () {

    this.initChart ()

  }
}

</script>
